import { render, staticRenderFns } from "./WithdrawWizard.vue?vue&type=template&id=3173db10&lang=pug"
import script from "./WithdrawWizard.vue?vue&type=script&lang=js"
export * from "./WithdrawWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports